module.exports = __webpack_public_path__ + "media/images/haircut/cover-mobile@3x-e319f64728d0c4ae10976cd1df7d5659.jpg";